<template>
<div class="vliveTrailer">
    <div>
        <!--<el-switch v-model="trailer.isopenpreview" active-text="功能开启后，直播开始推流之前会播放预告片" @change="switchStatus"></el-switch>-->
        <span class="switch"  @click.stop="switchStatus">
            <el-switch v-model="trailer.isopenpreview" active-text="功能开启后，直播开始推流之前会播放预告片" disabled></el-switch>
        </span>
    </div>
    <div v-if="trailer.isopenpreview">
        <div class="upload-video">
            <uploadFile :uploadType="uploadVideoType" @setFile="setFile" :fileRule="fileRule"></uploadFile>
            <el-button type="warning" class="btn" @click="openVideoScrollBox">素材库</el-button>
        </div>
        <div class="video-preview" v-if="trailer.videoInfo">
            <video :src="trailer.videoInfo.furl +'?'+timestamp" controls preload></video>
        </div>
    </div>
    <scrollBox ref="videoScrollBox" :uploadType="uploadVideoType" @saveMaterialFile="setMaterialVideofile"></scrollBox>
</div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import UploadFile from 'base/upload/uploadFile'
import {editVliveTrailerStatus, editVliveTrailer} from 'api/api'
import {formatFileInfo} from 'common/js/tools'
import ScrollBox from 'base/scrollBox/scrollBox'
export default {
    name: 'vliveTrailer',
    data() {
        return {
            timestamp: new Date().getTime(), // 时间戳
            trailer: {
                isopenpreview: false, // 0 关闭 1 开启
                videoInfo: {
                    duration: '',
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimeType: '',
                    objecttype: '',
                    furl: ''
                }
            },
            uploadVideoType: {
                catecode: '95',
                datatype: 'VIDEO'
            },
            fileRule: {
                btnName: '选择视频',
                cls: '',
                accept: 'video/mp4',
                size: 5 * 1024,
                width: '',
                height: ''
            },
            settingType: 'isopenpreview' // isopenpreview 预告片 isopencover 引导封面 isopenmp 关注公众号 isopenenroll 报名
        }
    },
    mounted() {
    },
    methods: {
        // 打开视频素材库选择框
        openVideoScrollBox() {
            this.$refs.videoScrollBox.openDialog()
        },
        // 设置素材库选择的视频信息
        setMaterialVideofile(file) {
            this.setFile(file)
        },
        switchStatus() {
            let status = !this.trailer.isopenpreview ? 1 : 0
            let tip = !this.trailer.isopenpreview ? '开启预告片' : '关闭预告片'
            this.$confirm(`确定${tip}？`, '提示', {
                cancelButtonText: '取消',
                confirmButtonText: '确定'
            }).then(() => {
                this._editStatus(status, tip)
            })
        },
        _editStatus(status, tip) {
            editVliveTrailerStatus({
                data: {
                    assetinnerid: this.vliveModel.assetinnerid,
                    settingType: this.settingType,
                    settingValue: status
                },
                success: data => {
                    this.$message.success(`${tip}成功！`)
                    this.trailer.isopenpreview = !this.trailer.isopenpreview
                    this.setVliveTrailer(Object.assign({}, this.trailer))
                    this.setLoading(false)
                },
                error: data => {
                    this.trailer.isopenpreview = !this.trailer.isopenpreview
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        setFile(file) {
            this.timestamp = new Date().getTime()
            this.setLoading(true)
            editVliveTrailer({
                data: {
                    assetinnerid: this.vliveModel.assetinnerid,
                    videoInfo: formatFileInfo(file)
                },
                success: data => {
                    this.$message.success('保存成功！')
                    this.trailer.videoInfo = file
                    this.setVliveTrailer(Object.assign({}, this.trailer))
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setVliveTrailer',
            'setLoading'
        ])
    },
    filters: {},
    watch: {
        vliveModel: {
            handler: function() {
                this.trailer = Object.assign({}, this.vliveModel.trailer)
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters([
            'vliveModel',
            'loading'
        ])
    },
    components: {
        UploadFile,
        ScrollBox
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.vliveTrailer {
    .upload-video{
        margin: 30px 0;
        @include flexBox(flex-start);
        .btn{
            margin-left: 30px;
        }
    }
    .video-preview{
        video{
            width: 320px;
        }
    }
}
</style>
